import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import { useServicesStore } from "../../store/services-provided/servicesStore";
import STRINGS from "../../utils/strings";
import CheckBox from "../fields/CheckBox";

import ServicesListItem from "./ServicesListItem";

export default function ServicesList({ data = [], serviceType }) {
  const {
    selectedAvailableServices,
    setSelectedAvailableServices,
    selectedProvidedServices,
    setSelectedProvidedServices,
    servicesToBeAdded,
  } = useServicesStore();

  const onChangeSelectAll = (checked) => {
    if (!checked) {
      const pageIds = new Set(selectableItems.map(getServiceId));

      const updated = selectedServices.filter((service) => !pageIds.has(getServiceId(service)));

      isAvailableService
        ? setSelectedAvailableServices(updated)
        : setSelectedProvidedServices(updated);

      return;
    }

    const existingIds = new Set(selectedServices.map(getServiceId));

    const toAdd = selectableItems.filter((item) => !existingIds.has(getServiceId(item)));

    const updated = [...selectedServices, ...toAdd];

    isAvailableService
      ? setSelectedAvailableServices(updated)
      : setSelectedProvidedServices(updated);
  };

  const getServiceId = (obj) => obj?.id ?? obj?.service?.id;

  const isAvailableService = serviceType === STRINGS.SERVICE_TYPE.AVAILABLE;

  const selectedServices = isAvailableService
    ? selectedAvailableServices
    : selectedProvidedServices;

  const selectableItems = isAvailableService
    ? data.filter(
        (item) => !servicesToBeAdded.some((service) => getServiceId(service) === getServiceId(item))
      )
    : data;

  const isSelectAllChecked =
    selectableItems.length > 0 &&
    selectableItems.every((item) =>
      selectedServices.some((service) => getServiceId(service) === getServiceId(item))
    );

  const handleClick = (checked, item) => {
    const itemId = getServiceId(item);

    if (isAvailableService) {
      setSelectedAvailableServices(
        checked
          ? [...selectedAvailableServices, item]
          : selectedAvailableServices.filter((service) => getServiceId(service) !== itemId)
      );
      return;
    }

    if (serviceType === STRINGS.SERVICE_TYPE.PROVIDED) {
      setSelectedProvidedServices(
        checked
          ? [...selectedProvidedServices, item]
          : selectedProvidedServices.filter((service) => getServiceId(service) !== itemId)
      );
    }
  };

  if (data.length === 0) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Typography sx={{ color: HNSColors.neutrals[500] }}>Nothing to show</Typography>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col gap-4">
      <CheckBox
        checked={isSelectAllChecked}
        handleClick={onChangeSelectAll}
        label={
          <Typography sx={{ color: HNSColors.neutrals[400] }}>
            {STRINGS.HEADERS.SELECT_ALL}
          </Typography>
        }
      />
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
        <div className="flex flex-col gap-4 px-2">
          {data.map((item) => {
            const itemId = getServiceId(item);

            let checked = false;
            let addedAvailableToProvided = false;

            if (isAvailableService) {
              checked = selectedAvailableServices.some(
                (service) => getServiceId(service) === itemId
              );

              addedAvailableToProvided = servicesToBeAdded.some(
                (service) => getServiceId(service) === itemId
              );
            } else {
              checked = selectedProvidedServices.some(
                (service) => getServiceId(service) === itemId
              );
            }

            return (
              <ServicesListItem
                key={itemId}
                data={item}
                handleClick={handleClick}
                checked={checked}
                hideCheckbox={addedAvailableToProvided}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
